<form class="form" id="performa_add_form" [formGroup]="proformaSettingsForm" (ngSubmit)="onSubmit()">
	<div class="card card-flush">
		<div class="card-body">
			<div class="fv-row row mb-15">
				<div class="col-md-4 col-sm-12 d-flex flex-column">
					<label for="salesAgreement" class="mb-0 d-flex align-items-center">
						Sales Agreement <span class="text-danger">*</span>
					</label>
					<textarea
						formControlName="sales_agreement"
						id="salesAgreement"
						class="form-control form-control-md min-h-200px"
						[class.is-invalid]="proformaSettingsForm.get('sales_agreement')?.invalid && proformaSettingsForm.get('sales_agreement')?.touched"
						placeholder="Enter sales agreement details">
					</textarea>
					<div *ngIf="proformaSettingsForm.get('sales_agreement')?.invalid && proformaSettingsForm.get('sales_agreement')?.touched"
						 class="invalid-feedback">
						Sales Agreement is required
					</div>
				</div>
				<div class="col-md-4 col-sm-12 d-flex flex-column">
					<label for="adminComment" class="mb-0 d-flex align-items-center">
						Admin Comment <span class="text-danger">*</span>
					</label>
					<textarea
						formControlName="admin_comments"
						id="adminComment"
						class="form-control form-control-md min-h-200px"
						[class.is-invalid]="proformaSettingsForm.get('admin_comments')?.invalid && proformaSettingsForm.get('admin_comments')?.touched"
						placeholder="Enter admin comments">
					</textarea>
					<div *ngIf="proformaSettingsForm.get('admin_comments')?.invalid && proformaSettingsForm.get('admin_comments')?.touched"
						 class="invalid-feedback">
						Admin Comment is required
					</div>
				</div>
				<div class="col-md-4 col-sm-12 d-flex flex-column">
					<label for="shipmentRemark" class="mb-0 d-flex align-items-center">
						Shipment Remark <span class="text-danger">*</span>
					</label>
					<textarea
						formControlName="shipment_remark"
						id="shipmentRemark"
						class="form-control form-control-md min-h-200px"
						[class.is-invalid]="proformaSettingsForm.get('shipment_remark')?.invalid && proformaSettingsForm.get('shipment_remark')?.touched"
						placeholder="Enter shipment remarks">
					</textarea>
					<div *ngIf="proformaSettingsForm.get('shipment_remark')?.invalid && proformaSettingsForm.get('shipment_remark')?.touched"
						 class="invalid-feedback">
						Shipment Remark is required
					</div>
				</div>
			</div>
			<div class="d-flex justify-content-start align-center mb-5">
				<button
					type="submit"
					class="btn btn-sm btn-primary me-3"
					[disabled]="isLoading">
					<span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
					{{ isLoading ? 'Updating...' : 'Update' }}
				</button>
				<button type="button" class="btn btn-sm btn-dark" [disabled]="isLoading">Cancel</button>
			</div>
		</div>
	</div>
</form>
